import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { GetServiceProcessHistory } from '../../../Services/ToDoViewAllList'
import {
    type ServiceProcessHistoryPageProp,
    type ServiceProcessHistoryState,
} from '../../../Types/ToDoViewAllList'
import { Col, Row, Spin } from 'antd'
import { GetUserList } from '../../../Services/User'

const ServiceProcessHistory = (
    props: ServiceProcessHistoryPageProp
): React.ReactElement => {
    const {
        serviceprocessId,
        serviceProcessHistoryList,
        serviceId,
        userList,
        isLoading,
    } = props
    const dispatch = useDispatch()

    useEffect(() => {
        GetServiceProcessHistory(dispatch, serviceprocessId)
    }, [serviceprocessId])
    useEffect(() => {
        GetUserList(dispatch)
    }, [dispatch])

    const getUserNameById = (userId: number): string => {
        if (userId === null || userId === undefined) {
            return ''
        }
        const user = userList?.find((u) => u?.value === userId)
        return user?.label ?? ''
    }

    // 1. Get the first group where any action has ID 1240, 1241, or 1242
    const firstReviewerGroup =
        serviceProcessHistoryList?.serviceProcessActionGroupHistoryList?.find(
            (group) =>
                group.serviceProcessActionHistoryList?.some(
                    (action) =>
                        action.serviceActionId === 1240 ||
                        action.serviceActionId === 1241 ||
                        action.serviceActionId === 1242
                )
        )

    return (
        <Spin spinning={isLoading} size="large">
            <div>
                <div>
                    <h4>
                        Remarks:
                        {
                            serviceProcessHistoryList
                                ?.serviceProcessCheckListHistory?.remarks
                        }
                    </h4>
                </div>
                {serviceId === 10 ? (
                    <div>
                        {firstReviewerGroup !== undefined &&
                        firstReviewerGroup !== null ? (
                            <div>
                                <h3 style={{ fontWeight: 600 }}>
                                    Processor Information
                                </h3>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        Assign To:{' '}
                                        {getUserNameById(
                                            firstReviewerGroup
                                                .serviceProcessActionHistoryList[0]
                                                .assignedToBeforeReview
                                        )}
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        Assign Date and Time:{' '}
                                        {
                                            firstReviewerGroup
                                                .serviceProcessActionHistoryList[0]
                                                .assignedDateBeforeReview
                                        }
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        Processor Remarks:{' '}
                                        {
                                            firstReviewerGroup
                                                .serviceProcessActionHistoryList[0]
                                                .remarks
                                        }
                                    </Col>
                                </Row>

                                <h3 style={{ fontWeight: 600 }}>
                                    Approver Information
                                </h3>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        Approver:{' '}
                                        {getUserNameById(
                                            firstReviewerGroup
                                                .serviceProcessActionHistoryList[0]
                                                .reviewUserId
                                        )}
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        Assign Date and Time:{' '}
                                        {
                                            firstReviewerGroup
                                                .serviceProcessActionHistoryList[0]
                                                .reviewStartedDate
                                        }
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        Completed Date and Time:{' '}
                                        {
                                            firstReviewerGroup
                                                .serviceProcessActionHistoryList[0]
                                                .reviewCompletedDate
                                        }
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            serviceProcessHistoryList?.serviceProcessActionGroupHistoryList?.map(
                                (data, index) => (
                                    <>
                                        <div key={data.serviceActionGroupId}>
                                            <u>
                                                <h2>
                                                    {data?.actionGroupName}:
                                                </h2>
                                            </u>
                                        </div>

                                        <div>
                                            {data?.serviceProcessActionHistoryList?.map(
                                                (item) => (
                                                    <>
                                                        <h3
                                                            style={{
                                                                fontWeight: 400,
                                                            }}
                                                        >
                                                            {item.actionName}:
                                                        </h3>
                                                        <div>
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    <p>
                                                                        <span
                                                                            style={{
                                                                                fontWeight: 700,
                                                                                marginRight: 5,
                                                                            }}
                                                                        >
                                                                            Status
                                                                            :
                                                                        </span>
                                                                        {
                                                                            item.completeStatus
                                                                        }
                                                                    </p>
                                                                </Col>
                                                                <Col span={8}>
                                                                    {item?.processHistoryStatusList?.map(
                                                                        (
                                                                            datas
                                                                        ) => (
                                                                            <>
                                                                                <div>
                                                                                    <p>
                                                                                        <span
                                                                                            style={{
                                                                                                fontWeight: 700,
                                                                                                marginRight: 5,
                                                                                            }}
                                                                                        >
                                                                                            Assign
                                                                                            Date
                                                                                            :
                                                                                        </span>
                                                                                        {
                                                                                            datas.assignDate
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            <Row gutter={24}>
                                                                <Col span={8}>
                                                                    {item?.processHistoryStatusList?.map(
                                                                        (
                                                                            datas
                                                                        ) => (
                                                                            <>
                                                                                <div>
                                                                                    <p>
                                                                                        <span
                                                                                            style={{
                                                                                                fontWeight: 700,
                                                                                                marginRight: 5,
                                                                                            }}
                                                                                        >
                                                                                            Remarks
                                                                                            :
                                                                                        </span>
                                                                                        {
                                                                                            datas.userRemarks
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </>
                                                )
                                            )}
                                        </div>
                                    </>
                                )
                            )
                        )}
                    </div>
                ) : (
                    serviceProcessHistoryList?.serviceProcessActionGroupHistoryList?.map(
                        (data, index) => (
                            <>
                                <div key={data.serviceActionGroupId}>
                                    <u>
                                        <h2>{data?.actionGroupName}:</h2>
                                    </u>
                                </div>

                                <div>
                                    {data?.serviceProcessActionHistoryList?.map(
                                        (item) => (
                                            <>
                                                <h3 style={{ fontWeight: 400 }}>
                                                    {item.actionName}:
                                                </h3>
                                                <div>
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            <p>
                                                                <span
                                                                    style={{
                                                                        fontWeight: 700,
                                                                        marginRight: 5,
                                                                    }}
                                                                >
                                                                    Status :
                                                                </span>
                                                                {
                                                                    item.completeStatus
                                                                }
                                                            </p>
                                                        </Col>
                                                        <Col span={8}>
                                                            {item?.processHistoryStatusList?.map(
                                                                (datas) => (
                                                                    <>
                                                                        <div>
                                                                            <p>
                                                                                <span
                                                                                    style={{
                                                                                        fontWeight: 700,
                                                                                        marginRight: 5,
                                                                                    }}
                                                                                >
                                                                                    Assign
                                                                                    Date
                                                                                    :
                                                                                </span>
                                                                                {
                                                                                    datas.assignDate
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </>
                                                                )
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            {item?.processHistoryStatusList?.map(
                                                                (datas) => (
                                                                    <>
                                                                        <div>
                                                                            <p>
                                                                                <span
                                                                                    style={{
                                                                                        fontWeight: 700,
                                                                                        marginRight: 5,
                                                                                    }}
                                                                                >
                                                                                    Remarks
                                                                                    :
                                                                                </span>
                                                                                {
                                                                                    datas.userRemarks
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </>
                                                                )
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </>
                                        )
                                    )}
                                </div>
                            </>
                        )
                    )
                )}
            </div>
        </Spin>
    )
}

const mapStateToProps = (state: any): ServiceProcessHistoryState => {
    return {
        serviceProcessHistoryList:
            state.dashboardInfo.serviceProcessHistoryList,
        userList: state.user.userList,
        isLoading: state.common.isLoading,
    }
}

export default connect(mapStateToProps)(ServiceProcessHistory)
